<a class="custom-button" [routerLink]="url"
  [ngStyle]="{ width: expand ? 'calc(100% - 20px)' : 'auto' }">
    <span class="background-effect"></span>
    <span class="button-text">{{actionText ? actionText : 'Resume'}}</span>
  </a>
  